import type { DonationMasterNameRecord } from "@project/types/donation-master";
import { JIVANDHARA_BASE, fetchListPage } from "../admin/list-api-helpers";
import type { ListQuery, PaginatedResult } from "@project/types/location";

const BASE = `${JIVANDHARA_BASE}/donation-main-category-master`;

class PublicDonationCategoryService {
  listActiveCategories = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<DonationMasterNameRecord>> =>
    fetchListPage<DonationMasterNameRecord>(`${BASE}/`, {
      page_size: 100,
      ...query,
      status: "active",
    });
}

export const publicDonationCategoryService =
  new PublicDonationCategoryService();
